<template>
  <v-breadcrumbs
    :items="items"
    v-if="items.length > 0"
  >
    <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :to="item.to"
          :disabled="!item.to"
        >
          {{ $t(item.text) }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data() {
    return {
      items: [],
    };
  },
  watch: {
    $route() {
      this.refresh();
    },
  },
  mounted() {
    this.refresh();
    this.$root.$on('update-breadcrumbs', (breadcrumb) => {
      this.items = breadcrumb;
    });
  },
  beforeDestroy() {
    this.$root.$off('update-breadcrumbs');
  },
  methods: {
    refresh() {
      const { breadcrumb } = this.$route.meta;
      if (breadcrumb) {
        this.items = breadcrumb;
      } else {
        this.items = [];
      }
    },
  },
};
</script>
